export default __webpack_public_path__ + "static/logo-e7ea9b5d280e7666613fe56cf34b7728.png";